import * as React from "react";
import { NavLink, useLocation } from "react-router-dom";
import clsx from "clsx";
import { MenuItem } from "../../../../store/menuSlice";

interface CollapsibleMenuItemProps {
  item: MenuItem;
  isFavorited: boolean;
  onToggleFavorite: (id: string) => void;
}

export const CollapsibleMenuItem: React.FC<CollapsibleMenuItemProps> = ({ item, isFavorited, onToggleFavorite }) => {
  const { pathname } = useLocation();
  const isActive = item.customIsActive ? item.customIsActive(pathname) : pathname.startsWith(item.url.split("?")[0]);

  return (
    <div className="collapsible-menu-item" data-guide={`menu-${item.label}`}>
      <NavLink
        to={item.url}
        tabIndex={isActive ? -1 : 0}
        className={clsx("collapsible-menu-item-link", {
          selected: isActive,
        })}
      >
        <div className="collapsible-menu-item-link-content">
          {item.icon && <div className="menu-link-icon">{item.icon}</div>}
          <span>{item.label}</span>
        </div>
      </NavLink>

      {isFavorited || item.canFavorite === false ? null : (
        <button
          className={clsx("collapsible-menu-item-pin")}
          onClick={() => onToggleFavorite(item.id)}
          aria-label={"Pin to favorites"}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill={"none"} stroke="currentColor" strokeWidth="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </button>
      )}
    </div>
  );
};
